<mat-card>
  <mat-card-content>
    <app-terms-display
      [termsLabel]="'Terms of service'"
      [header]="'terms of service'"
      [agreeLabel]="'I agree to the terms of service'"
      [contentWidgetTag]="ContentWidgetTag.PatTerms"
      [effectiveDateSetting]="Setting.PatTermsDate"
      (submitted)="submit()">
    </app-terms-display>
  </mat-card-content>
</mat-card>